import {Component, Injectable} from '@angular/core';
import {NgbTimeStruct, NgbTimeAdapter} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbTimeConverter extends NgbTimeAdapter<string> {

    fromModel(timeString: string): NgbTimeStruct {
        if (!timeString) {
          return null;
        }
        const parts = timeString.split(':', 3);
        return {
            hour: parseInt(parts[0], 10),
            minute: parseInt(parts[1], 10),
            second: parseInt(parts[2], 10)
        };
    }
    
    toModel(time: NgbTimeStruct): string {
        if (!time) {
          return null;
        }
        time.hour = (time.hour) ? time.hour : 0;
        time.minute = (time.minute) ? time.minute : 0;
        time.second = (time.second) ? time.second : 0;
        return `${this.pad(time.hour)}:${this.pad(time.minute)}:${this.pad(time.second)}`;
    }

    public pad(number): string {
        return number < 10 ? `0${number}` : number;
    }

}


// WEBPACK FOOTER //
// ./src/app/bi/common/service/ngbTimeConverter.utils.ts